import { ReactElement } from 'react'
import {
    Applications,
    FMTABS,
    TAB_PAGE_VIEW,
    URLSearchParamsKeys,
} from '../../../../constants/constants'
import Entity from '../../../Entity/EntityList'
import { useSearchParams } from 'react-router-dom'
import { Box } from '@mui/material'
import ViewEntity from '../../../ViewEntity'

interface IDeviceEntityList {
    sensorEntityTemplateId: string
}

const DeviceEntityList = (props: IDeviceEntityList): ReactElement => {
    const { sensorEntityTemplateId } = props
    const [searchParams] = useSearchParams()
    const tabPageView =
        searchParams.get(URLSearchParamsKeys.pageView) ||
        TAB_PAGE_VIEW.LIST_VIEW
    const isDeviceListView = TAB_PAGE_VIEW.LIST_VIEW === tabPageView
    return isDeviceListView ? (
        <Box sx={{ height: '100%' }}>
            <Entity
                tabIndex={FMTABS.DEVICE_VIEW}
                applicationId={Applications.facilityMonitoring.id}
                templateId={sensorEntityTemplateId}
            />
        </Box>
    ) : (
        <ViewEntity />
    )
}

export default DeviceEntityList
